import { Component, OnInit, Input } from '@angular/core';
import { PrzychodyKoszty } from '../../../shared/models/przychody-koszty.model';

import { Chart, LineController, Line, Point, LinearScale, CategoryScale, Tooltip, Legend } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-przychody-koszty-wykres',
  templateUrl: './przychody-koszty-wykres.component.html',
  styleUrls: ['./przychody-koszty-wykres.component.scss'],
})
export class PrzychodyKosztyWykresComponent implements OnInit {

  @Input() okresy: string[];
  @Input() przychody: PrzychodyKoszty[];
  @Input() koszty: PrzychodyKoszty[];

  private kolorPrzychod = '#00d68f';
  private kolorKoszt = '#ff3d71';

  private etykietaPrzychody: string;
  private etykietaKoszty: string;

  chart: Chart = [];

  ukryjWykres: boolean = true;

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.getEtykiety();
    this.translate.onLangChange.subscribe(() => {
      this.chart.data.datasets[0].label = this.getEtykietaPrzychody();
      this.chart.data.datasets[1].label = this.getEtykietaKoszty();
      this.update();
    });

    Chart.register(LineController, Line, Point, LinearScale, CategoryScale, Tooltip, Legend);
    this.chart = new Chart('chart', {
      type: 'line',
      data: {
        labels: this.okresy,
        datasets: [
          {
            label: this.etykietaPrzychody,
            data: this.przychody,
            borderColor: this.kolorPrzychod,
            fill: false,
          },
          {
            label: this.etykietaKoszty,
            data: this.koszty,
            borderColor: this.kolorKoszt,
            fill: false,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
        },
        tooltips: {
          mode: 'index',
          intersect: true,
        },
        scales: {
          x: {
            type: 'category',
            offset: true,
          },
          y: {
            type: 'linear',
            beginAtZero: true,
          },
        },
      },
    });

  }

  public update() {
    this.chart.update();
  }

  public zmienWidocznoscWykresu(event: any) {
    this.ukryjWykres = !this.ukryjWykres;
  }

  private getEtykiety() {
    this.etykietaKoszty = this.getEtykietaKoszty();
    this.etykietaPrzychody = this.getEtykietaPrzychody();
  }

  private getEtykietaKoszty(): string {
    return this.translate.instant('etykieta.koszty');
  }

  private getEtykietaPrzychody(): string {
    return this.translate.instant('etykieta.przychody');
  }
}
